// src/components/FindGathering.js
// This page is no longer part of the booking flow.
// Slot confirmation now routes directly from Slots → checkout or my-events.
// Anyone landing here (e.g. old bookmarks) is redirected to slots.
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const FoundGathering = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/slots', { replace: true });
  }, [navigate]);

  return null;
};

export default FoundGathering;
